var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.983.017c-8.508-.28-17.11 2.84-23.605 9.367l-.195.196H3.526c-3.135 0-4.704 3.808-2.49 6.033l5.07 5.093-1.878 1.886a3.164 3.164 0 0 0 0 4.463l9.84 9.885a3.129 3.129 0 0 0 4.442 0l1.877-1.886 4.88 4.903c2.218 2.229 6.006.649 6.006-2.501V24.118l.384-.386C38.152 17.207 41.26 8.565 40.983.017ZM12.402 18.564a2.654 2.654 0 0 1-2.649-2.661c0-1.47 1.186-2.661 2.649-2.661a2.654 2.654 0 0 1 2.649 2.66c0 1.47-1.186 2.662-2.649 2.662Zm7.946-5.322a2.654 2.654 0 0 1 2.648 2.66c0 1.47-1.185 2.662-2.648 2.662a2.654 2.654 0 0 1-2.649-2.661c0-1.47 1.185-2.661 2.649-2.661Zm-2.98 16.63v-3.326c4.198 0 7.615-3.432 7.615-7.65h3.31c0 6.05-4.9 10.976-10.925 10.976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.8028a05b06a7e06ca1a1a0b918b402d3.svg";
export { ForwardRef as ReactComponent };